import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

// Ícone de livro com símbolo de vetorização/processamento
export const BookVectorization = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g fill="currentcolor">
      {/* Livro */}
      <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" />
      {/* Setas de processamento/vetorização */}
      <path d="M14 14l2-2-2-2v1.5h-2v1h2V14z" opacity="0.7" />
      <path d="M16 17l2-2-2-2v1.5h-2v1h2V17z" opacity="0.5" />
    </g>
  </SvgIcon>
)

export default BookVectorization



// WEBPACK FOOTER //
// ./src/icons/BookVectorization.js